import { Pencil, X, Check, Upload } from "lucide-react";

export default function PlatformCoverageAoiToolbar({
  draw,
  hasGeometry,
  onSave,
  onCancel,
  onUpload,        // ← new prop
}) {
  const isDrawing = Boolean(draw?.drawing && draw?.mode === "polygon");
  const canCancel = isDrawing || hasGeometry;

  const startPolygon = () => {
    if (!draw) return;
    draw.stopDrawing?.();
    draw.delete?.();
    draw.lastFeature = null;
    draw.startPolygon?.();
  };

  const cancel = () => {
    if (!draw) return;
    draw.stopDrawing?.();
    draw.delete?.();
    draw.lastFeature = null;
    onCancel?.();
  };

  const save = () => {
    if (!draw?.lastFeature) return;
    onSave?.();
  };

  const buttonBase =
    "group relative flex items-center justify-center " +
    "w-[26px] h-[26px] rounded-md bg-bg-softer " +
    "border border-[#1a1d24] hover:bg-bg-soft transition";
  const activeButton = "border-aoi-neon shadow-[0_0_8px_2px_#16f2d4]";
  const iconActive = "text-aoi-neon drop-shadow-[0_0_4px_#16f2d4]";
  const iconInactive = "text-gray-300";

  const NeonBar = () => (
    <div className="absolute bottom-0 left-0 w-full h-[2px] bg-aoi-neon shadow-[0_0_8px_3px_#16f2d4]" />
  );

  return (
    <div className={[
      "absolute top-2 left-3 z-30 flex items-center gap-1.5",
      "px-2 py-2 bg-bg-soft/90 backdrop-blur",
      "border border-[#1a1d24] rounded-lg shadow-lg",
    ].join(" ")}>

      {/* DRAW */}
      <button
        onClick={startPolygon}
        className={`${buttonBase} ${isDrawing ? activeButton : ""}`}
        title="Draw polygon"
      >
        <Pencil size={15} className={isDrawing ? iconActive : iconInactive} />
        {isDrawing && <NeonBar />}
      </button>

      {/* UPLOAD */}
      <button
        onClick={onUpload}
        className={buttonBase}
        title="Import file (GeoJSON, KML, KMZ, Shapefile ZIP)"
      >
        <Upload size={14} className={iconInactive} />
      </button>

      {/* CANCEL */}
      <button
        onClick={cancel}
        disabled={!canCancel}
        className={`${buttonBase} ${!canCancel ? "opacity-40 pointer-events-none" : ""}`}
        title="Cancel"
      >
        <X size={14} className="text-gray-300" />
      </button>

      {/* SAVE */}
      <button
        onClick={save}
        disabled={!hasGeometry}
        className={
          hasGeometry
            ? `${buttonBase} border-aoi-neon shadow-[0_0_8px_2px_#16f2d4]`
            : `${buttonBase} opacity-40 pointer-events-none`
        }
        title="Save coverage AOI"
      >
        <Check size={14} className={hasGeometry ? iconActive : "text-fg-secondary"} />
        {hasGeometry && <NeonBar />}
      </button>
    </div>
  );
}